import { TemplatePlcTable } from './table'
import React, { useState } from 'react'
import { TemplatePlcToolbar } from './toolbar'
import { PlcItem, TemplatePlcProps, TemplateReferenceItem } from '../interface'
import { message, Modal } from 'antd'
import { TemplatePlcEdit } from './edit'
import { getFormatMessage } from '../../utils/utils'
import { plcTypeItems, portNoItems } from '../../shared/SelectData'

export const TemplatePlc: React.FC<TemplatePlcProps> = (
  props: TemplatePlcProps
) => {
  const { onDelete, onRefRelease } = props
  const [visible, setVisible] = useState<boolean>(false)
  const [formResult, setFormResult] = useState<boolean>(false)
  const [selected, setSelected] = useState<PlcItem[]>([])
  const [formData, setFormData] = useState<{
    item
    portNoItems
    plcTypeItems
  }>()
  const formatMessage = getFormatMessage()
  const [references, setReferences] = useState<TemplateReferenceItem[]>([])

  const validateFormData = (item?: PlcItem): boolean => {
    const exist = props.data?.find(
      (x) => x.alias == item?.alias && x.id != item?.id
    )
    if (exist) {
      message.error(formatMessage({ id: 'app.template.plc.existName' }))
      return false
    }
    return true
  }

  const handleFormValidate = (ok: boolean, item?: PlcItem): boolean => {
    setFormResult(false)
    if (ok && validateFormData(item)) {
      setVisible(false)
      return true
    }
    return false
  }

  const handleFormSubmit = (item: PlcItem) => {
    if (props.onFormSubmit) {
      props.onFormSubmit(item)
    }
  }

  const handleCreate = () => {
    resetFormData()
    setReferences([])
    setVisible(true)
  }

  const handleEdit = (item: PlcItem) => {
    const refs = props.onRefCheck?.([item])
    resetFormData(item)
    setReferences(refs || [])
    setVisible(true)
  }

  const handleDelete = (item: PlcItem) => {
    onDelete?.([item])
  }

  const handleBatchDelete = async () => {
    if (!selected || selected.length <= 0) {
      message.error('请选择需要删除的条目')
      return
    }
    const result = await onDelete?.(selected)
    if (result) {
      setSelected([])
    }
  }

  const resetFormData = (item?: PlcItem) => {
    // 已使用串口
    const usedPortNos =
      props.data
        ?.filter((x) => x.type == 'serial')
        .map((x) => x.serial?.portNo) || []
    // 剩余可用串口
    let leftPortNos = portNoItems.filter((x) => !usedPortNos.includes(x.value))

    if (item && item.id) {
      // 编辑
      if (leftPortNos.length <= 0) {
        // 没有可用串口，则显示当前编辑项目
        leftPortNos = portNoItems.filter((x) => x.value == item?.serial?.portNo)
      } else {
        const exists = leftPortNos.find((x) => x.value == item?.serial?.portNo)
        if (!exists) {
          leftPortNos = portNoItems.filter(
            (x) =>
              !usedPortNos.includes(x.value) || x.value == item?.serial?.portNo
          )
        }
      }
    } else {
      // 新增
      item = {
        deviceMode: 0,
        slaveStationNo: 1
      }
      if (leftPortNos.length > 0) {
        item.type = 'serial'
        item.serial = {
          portNo: leftPortNos[0].value
        }
      } else {
        item.type = 'ethernet'
        item.ethernet = {}
      }
    }

    const leftPlcTypes =
      leftPortNos.length <= 0 ? plcTypeItems.slice(1) : plcTypeItems
    setFormData({
      item: item,
      portNoItems: leftPortNos,
      plcTypeItems: leftPlcTypes
    })
  }

  const handleRefRelease = (item: TemplateReferenceItem) => {
    if (!formData?.item) return
    const refs = onRefRelease?.([formData?.item], item)
    setReferences(refs || [])
  }

  return (
    <div>
      <TemplatePlcToolbar
        {...props}
        selectable={selected.length > 0}
        onCreate={handleCreate}
        onBatchDelete={handleBatchDelete}
      />
      <TemplatePlcTable
        {...props}
        selectable
        selectionType='checkbox'
        onEdit={handleEdit}
        onDelete={handleDelete}
        onSelect={setSelected}
      />
      <Modal
        visible={visible}
        onCancel={() => setVisible(false)}
        title={
          formData?.item?.id
            ? formatMessage({
                id: 'app.template.plc.edit.title',
                parameters: { name: formData?.item?.plcName }
              })
            : formatMessage({ id: 'app.template.modalTitle' })
        }
        width={800}
        bodyStyle={{ paddingTop: 0 }}
        onOk={() => setFormResult(true)}
        okText={formatMessage({ id: 'app.modal.ok' })}
        cancelText={formatMessage({ id: 'app.modal.cancel' })}
        destroyOnClose={true}
        maskClosable={false}
      >
        <TemplatePlcEdit
          {...props}
          formResult={formResult}
          formData={formData}
          references={references}
          onFormValidate={handleFormValidate}
          onFormSubmit={handleFormSubmit}
          onRefRelease={handleRefRelease}
        />
      </Modal>
    </div>
  )
}
